import { Cookies, useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { Button } from '@/ui/components/arandu/button';
import { notification } from '@/ui/components/arandu/notification';
import { Icon } from '@/ui/components/icon';

export function CookiesPolicyBanner() {
  const [cookies] = useCookies(['cookies-policy-accepted']);
  const cookie = cookies['cookies-policy-accepted'];
  const { t } = useTranslation();

  if (!cookie) {
    notification({
      notificationType: 'iconShape',
      secondaryAction: <Button onClick={() => acceptCookies()}>{t('accept')}</Button>,
      primaryAction: (
        <Button
          hierarchy='tertiary'
          onClick={() => {
            window.location.href = 'https://www.linka.la/terms-and-politics/pt';
          }}
        >
          {t('privacy_policies')}
        </Button>
      ),
      description: t('privacy_policies-description'),
      title: t('privacy_policies'),
      icon: () => <Icon icon='shieldCheck' />,
      open: !cookie,
    });
  }

  return null;
}

const FOUR_HUNDRED_DAYS_IN_SECONDS = 34560000;

export const acceptCookies = () => {
  const cookies = new Cookies();
  cookies.set('cookies-policy-accepted', 'true', {
    maxAge: FOUR_HUNDRED_DAYS_IN_SECONDS,
    secure: process.env.NODE_ENV === 'production',
    path: '/',
    httpOnly: false,
  });
};
